import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Configuracoes } from "../entities/configuracoes";
const BASE_URL = Configuracoes.API_IMAGENS_PRODUTOS;

interface Produto {
  imagem: string;
  produtoDescricao: string;
  produtoReferencia: string;
  quantidade: number;
  preco: number;
  total: number;
  tamanho: string;
}

interface Item {
  descricao_produto: string;
  cor: number;
  tamanho: string;
  quantidade: number;
  preco: number;
}

export async function gerarPDFComProdutos(produtos: Produto[]) {
  const doc = new jsPDF();
  const startX = 10;
  let startY = 20;

  // Título
  doc.setFontSize(16);
  doc.text('Lista de Produtos', startX, startY);
  startY += 10;

  // Cabeçalho da tabela
  doc.setFontSize(10);
  doc.text('Imagem', startX, startY);
  doc.text('Descrição', startX + 30, startY);
  doc.text('Ref.', startX + 90, startY);
  doc.text('Qtd', startX + 115, startY);
  doc.text('Preço', startX + 130, startY);
  doc.text('Total', startX + 150, startY);
  doc.text('Tam.', startX + 170, startY);

  startY += 5;

  for (const produto of produtos) {
    const imageUrl = BASE_URL + produto.imagem;

    try {
      const imageData = await carregarImagemComoBase64(imageUrl);
      // Imagem do produto
      doc.addImage(imageData, 'JPEG', startX, startY, 20, 20);
    } catch (error) {
      console.error('Erro ao carregar imagem:', imageUrl);
    }

    // Dados do produto
    doc.text(produto.produtoDescricao, startX + 30, startY + 5, { maxWidth: 55 });
    doc.text(produto.produtoReferencia, startX + 90, startY + 5);
    doc.text(String(produto.quantidade), startX + 115, startY + 5);
    doc.text(produto.preco.toFixed(2), startX + 130, startY + 5);
    doc.text(produto.total.toFixed(2), startX + 150, startY + 5);
    doc.text(produto.tamanho, startX + 170, startY + 5);

    startY += 25;

    if (startY > 270) {
      doc.addPage();
      startY = 20;
    }
  }

  doc.save('produtos.pdf');
}


export function agruparPorProduto(itens: Item[]): Map<string, Item[]> {
  const map = new Map<string, Item[]>();
  for (const item of itens) {
    if (!map.has(item.descricao_produto)) {
      map.set(item.descricao_produto, []);
    }
    map.get(item.descricao_produto)!.push(item);
  }
  return map;
}

function dateTransform(dataOriginal) {
  const data = new Date(dataOriginal);

  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
  const ano = data.getFullYear();

  const dataFormatada = `${dia}/${mes}/${ano}`;

  return dataFormatada; // 04/07/202
}

export function gerarPDFPedidos(e: any, layout: number = 1): Promise<void> {
  async function carregarImagemComFallback(urlPrincipal: string, urlFallback: string): Promise<string> {
    try {
      const res = await fetch(urlPrincipal, { mode: 'cors' });
      if (!res.ok) throw new Error('Imagem principal indisponível');

      const blob = await res.blob();
      return await blobToBase64(blob);
    } catch (e) {
      const fallbackRes = await fetch(urlFallback);
      const fallbackBlob = await fallbackRes.blob();
      return await blobToBase64(fallbackBlob);
    }
  }

  // Helper para converter Blob em Base64
  function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
  return new Promise(async (resolve, reject) => {
    try {
      if (!e || !e.itens || !Array.isArray(e.itens)) {
        throw new Error('Dados do pedido inválidos ou incompletos.');
      }

      // const doc = new jsPDF();
      // Configuracoes.API_IMAGENS_PRODUTOS+item.imagem

      // const cliente = e.clientes?.[0]?.cliente || {};

      const col1 = [
        { label: 'Cliente:', value: e.nome_cliente || '-' },
        { label: 'Usuário:', value: e.nome_usuario || '-' },
        { label: 'Email:', value: e.email || '-' },
        { label: 'Telefone:', value: ` ${e?.telefone || '-'}` },
        { label: 'Endereço:', value: `${e?.endereco || '-'}` },
        { label: 'Transp.: ', value: `${e?.transportadora || '-'}` }
      ];

      const col2 = [
        { label: 'Código do Pedido:', value: e.numero_pedido || '-' },
        { label: 'Forma pgto.:', value: e.descricao_forma_pagamento },
        { label: 'Tipo:', value: e.tipo || '-' },
        { label: 'Data:', value: dateTransform(e.data_criacao) },
        { label: 'Status:', value: e.statusdescricao },
        { label: 'Cupom:', value: e.cupom_aplicado || '-' }
      ];

      // Logo e conteúdo
      const img = new Image();
      const fallbackUrl = 'assets/no-product-image.jpg';
      const logoUrl = fallbackUrl;

      const imagemBase64 = await carregarImagemComFallback(
        Configuracoes.API_IMAGENS + "logo.png",
        fallbackUrl
      );

      img.src = logoUrl;
      img.onload = async () => {
        try {
          const doc = new jsPDF();
          doc.addImage(imagemBase64, 'PNG', 15, 10, 50, 15);

          let y = 30;
          const lineHeight = 5;
          const col1Width = 100;
          const col2Width = 70;

          doc.setFontSize(7);

          const maxLines = Math.max(col1.length, col2.length);

          const pageWidth = doc.internal.pageSize.getWidth();
          const marginRight = 15; // espaço da direita

          for (let i = 0; i < maxLines; i++) {
            const x1 = 14;

            // Agora a col2 fica corretamente afastada da borda
            const x2 = pageWidth - col2Width - marginRight;
            const x2Value = x2 + 27;

            const col1Lines = col1[i]
              ? doc.splitTextToSize(String(col1[i].value), col1Width)
              : [];
            const col2Lines = col2[i]
              ? doc.splitTextToSize(String(col2[i].value), col2Width)
              : [];

            const maxWrappedLines = Math.max(col1Lines.length, col2Lines.length);

            for (let j = 0; j < maxWrappedLines; j++) {
              if (j === 0) {
                if (col1[i]) {
                  doc.setFont(undefined, 'bold');
                  doc.text(col1[i].label, x1, y);
                  doc.setFont(undefined, 'normal');
                  doc.text(col1Lines[j] || '', x1 + 20, y);
                }
                if (col2[i]) {
                  doc.setFont(undefined, 'bold');
                  doc.text(col2[i].label, x2, y);
                  doc.setFont(undefined, 'normal');
                  doc.text(col2Lines[j] || '', x2Value, y);
                }
              } else {
                if (col1[i]) {
                  doc.text(col1Lines[j] || '', x1 + 20, y);
                }
                if (col2[i]) {
                  doc.text(col2Lines[j] || '', x2Value, y);
                }
              }
              y += lineHeight;
            }
          }


          doc.setFont(undefined, 'bold');
          doc.text("Observações: ", 14, y);

          doc.setFont(undefined, 'normal');
          const texto = doc.splitTextToSize(e.observacao || '', 160);
          doc.text(texto, 34, y);

          // calcula altura da observação dinamicamente
          const alturaLinha = 6; // ajuste conforme fonte/tamanho
          const alturaObservacao = texto.length * alturaLinha;
          y += alturaObservacao + 4; // adiciona espaçamento depois da observação

          if (layout == 4) {
            const head = [['Imagem', 'Produtos', 'NCM', 'Cód.Barras', 'Qt.Tl', 'Vl.Uni', 'Vl.Uni/Imp', 'Vl.Tt', '%IPI', 'Vl.IPI']];

            const body = e.itens.map((item: any) => [
              '',
              `${item.descricao_produto?.trim() || ''}`,
              item.ncm || '-',
              item.barra || '-',
              item.quantidade || 0,
              `R$ ${item.preco?.toFixed(2) || '0,00'}`,
              `R$ ${item.preco?.toFixed(2) || '0,00'}`,
              `R$ ${(item.preco * item.quantidade)?.toFixed(2) || '0,00'}`,
              item.imp_ipi ? `${item.imp_ipi.toFixed(2)}%` : '-',
              item.imp_valoripi ? `R$ ${item.imp_valoripi.toFixed(2)}` : '-'
            ]);

            const itens = e.itens || [];
            const fallbackUrl = 'assets/no-product-image.jpg';

            const imagensBase64 = await Promise.all(
              itens.map(item =>
                carregarImagemComFallback(Configuracoes.API_IMAGENS_PRODUTOS + item.imagem, fallbackUrl)
              )
            );

            autoTable(doc, {
              startY: y,
              head,
              body,
              styles: {
                fontSize: 6,
                textColor: [0, 0, 0],
                cellPadding: { top: 6, bottom: 6, left: 2, right: 2 }
              },
              headStyles: {
                fontSize: 8,
                fillColor: [0, 0, 0],
                textColor: [255, 255, 255],
                cellPadding: { top: 3, bottom: 3, left: 2, right: 2 }
              },
              columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: 60 },
              },
              didDrawCell: (data) => {
                if (data.column.index === 0 && data.cell.section === 'body') {
                  const index = data.row.index;
                  const imagemBase64 = imagensBase64[index];
                  if (imagemBase64) {
                    doc.addImage(imagemBase64, 'JPEG', data.cell.x + 1, data.cell.y + 1, 10, 10);
                  }
                }
              },
              didParseCell: (data) => {
                if (data.column.index === 0 && data.cell.section === 'body') {
                  data.cell.text = [];
                }
              }
            });
          }

          if (layout === 3) {
            const produtos = agruparPorProduto(e.itens);
            let posY = y + 10; // começa depois da observação

            for (const [descricao, grupo] of produtos.entries()) {
              const tamanhosSet = new Set(grupo.map(i => i.tamanho));
              const tamanhos = Array.from(tamanhosSet).sort();

              const dadosPorCor = new Map<number, Record<string, { quantidade: number; preco: number }>>();

              for (const item of grupo) {
                if (!dadosPorCor.has(item.cor)) {
                  dadosPorCor.set(item.cor, {});
                }
                const registro = dadosPorCor.get(item.cor)!;

                if (!registro[item.tamanho]) {
                  registro[item.tamanho] = { quantidade: 0, preco: item.preco };
                }

                registro[item.tamanho].quantidade += item.quantidade;
                registro[item.tamanho].preco = item.preco;
              }

              const head = [['Cor', ...tamanhos, 'QTD', "Preço", "Total"]];
              const columnStyles: Record<number, any> = {};
              columnStyles[0] = { cellWidth: 40 };
              columnStyles[tamanhos.length + 1] = { cellWidth: 20 };
              columnStyles[tamanhos.length + 2] = { cellWidth: 25 };
              columnStyles[tamanhos.length + 3] = { cellWidth: 25 };

              const totaisPorTamanho: Record<string, number> = {};
              let totalGeralQtd = 0;
              let totalGeralValor = 0;

              const body = Array.from(dadosPorCor.entries()).map(([cor, tamanhosDados]) => {
                const linha = [cor.toString()];
                let totalQtd = 0;
                let precoUnit = 0;

                for (const tamanho of tamanhos) {
                  const dado = tamanhosDados[tamanho];
                  const qtd = dado?.quantidade || 0;
                  const preco = dado?.preco || 0;

                  linha.push(qtd.toString());

                  totalQtd += qtd;
                  precoUnit = preco || precoUnit;
                  totaisPorTamanho[tamanho] = (totaisPorTamanho[tamanho] || 0) + qtd;
                }

                const totalGeral = totalQtd * precoUnit;
                totalGeralQtd += totalQtd;
                totalGeralValor += totalGeral;

                linha.push(
                  totalQtd.toString(),
                  `R$ ${precoUnit.toFixed(2)}`,
                  `R$ ${totalGeral.toFixed(2)}`
                );

                return linha;
              });

              const linhaTotal = ['TOTAL'];
              for (const tamanho of tamanhos) {
                linhaTotal.push((totaisPorTamanho[tamanho] || 0).toString());
              }
              linhaTotal.push(
                totalGeralQtd.toString(),
                '',
                `R$ ${totalGeralValor.toFixed(2)}`
              );

              body.push(linhaTotal);

              autoTable(doc, {
                startY: posY,
                head: [[descricao]],
                body: [[]],
                styles: { fontSize: 8, textColor: [2, 2, 2] },
                headStyles: { fillColor: [3, 3, 3], textColor: 255, fontStyle: 'bold', halign: 'left' },
                theme: 'striped',
                margin: { left: 14, right: 14 },
              });
              autoTable(doc, {
                startY: posY + 6,
                head,
                body,
                styles: { fontSize: 8, textColor: [2, 2, 2] },
                headStyles: { fillColor: [3, 3, 3], textColor: 255, fontStyle: 'bold', halign: 'left' },
                theme: 'striped',
                margin: { left: 14, right: 14 },
                columnStyles,
                didDrawPage: (data) => {
                  posY = data.cursor.y + 0;
                },
                didParseCell: (data) => {
                  if (data.section === 'head' && data.row.index === 0) {
                    data.cell.styles.fillColor = [200, 200, 200];
                    data.cell.styles.textColor = [0, 0, 0];
                    data.cell.styles.fontStyle = 'bold';
                  }
                }
              });

              if (posY > 270) {
                doc.addPage();
                posY = 20; // margem superior
              }
            }
          }


          const esquerda = [
            { label: 'Qtd. de Itens:', value: e.itens.length },
            { label: 'Referências', value: e.itens.length },
            { label: '', value: '' },
            { label: '', value: '' }
          ];

          const direita = [
            { label: 'Valor Produtos: R$ ', value: e.subtotal },
            { label: 'Impostos: R$ ', value: e.impostos },
            // { label: 'Valor Cupom:', value: e.cupom_aplicado },
            { label: 'Descontos: R$ ', value: e.desconto },
            { label: 'Valor Frete: R$ ', value: e.fretevalor || 'R$ 0,00' },
            { label: 'Valor Total: R$ ', value: e.total },
          ];

          const headFooter = [['Resumo', '']];

          const bodyFooter: string[][] = [];
          for (let i = 0; i < Math.max(esquerda.length, direita.length); i++) {
            const row = [];

            if (esquerda[i]) {
              row.push({
                content: `${esquerda[i].label} ${esquerda[i].value}`,
                styles: { textColor: [0, 0, 0] }
              });
            } else {
              row.push({ content: '', styles: {} });
            }

            if (direita[i]) {
              row.push({
                content: `${direita[i].label} ${direita[i].value}`,
                styles: { textColor: [0, 0, 0] }
              });
            } else {
              row.push({ content: '', styles: {} });
            }

            bodyFooter.push(row);
          }

          const rodapeY = (doc as any).lastAutoTable.finalY + 10;


          autoTable(doc, {
            startY: rodapeY,
            head: headFooter,
            body: bodyFooter,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [0, 0, 0], textColor: 255, fontStyle: 'bold', halign: 'left' },
            columnStyles: {
              0: { cellWidth: 90 },
              1: { cellWidth: 90, halign: 'right' },
            }
          });
          const ua = navigator.userAgent;
          if (/^((?!chrome|crios|android).)*safari/i.test(ua)) {
            doc.save('pedido.pdf');
          } else {
            const blobUrl = doc.output('bloburl');
            window.open(blobUrl, '_blank');
          }
          resolve();
        } catch (err) {
          console.error('Erro ao gerar PDF:', err);
          alert('Erro ao gerar PDF. Verifique os dados do pedido.');
        }
      };

      img.onerror = () => {
        console.error('Erro ao carregar a imagem da logo.');
        alert('Erro ao carregar a imagem da logo.');
      };

    } catch (error) {
      console.error('Erro geral ao processar pedido:', error);
      alert('Erro ao gerar o PDF do pedido. Dados inválidos ou incompletos.');
    }
  });
}



// Função auxiliar para converter uma imagem em base64
function carregarImagemComoBase64(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/jpeg'));
      } else {
        reject('Canvas context not available');
      }
    };
    img.onerror = reject;
    img.src = url;
  });
}
